import { ErrorFragment } from "@graphql/error/error.g";
import { useCallback, useMemo, useState } from "react";

export const useFormErrorsAPI = () => {
  const [errorsAPI, setErrorsAPI] = useState<Record<string, string>>({});

  const updateErrorsAPI = useCallback(
    (errors: (ErrorFragment | null)[]) => {
      setErrorsAPI(
        errors.reduce(
          (acc, error) => {
            if (!error?.field || !error?.message) return acc;

            acc[error.field] = error.message;
            return acc;
          },
          {} as Record<string, string>,
        ),
      );
    },
    [setErrorsAPI],
  );

  return useMemo(
    () => ({ errorsAPI, updateErrorsAPI }),
    [errorsAPI, updateErrorsAPI],
  );
};
